<template>
  <Teleport to="body">
    <div
      v-if="gdprVisible"
      class="gdpr-banner"
      role="dialog"
      aria-modal="true"
      aria-label="Cookie consent"
    >
      <div class="gdpr-banner__inner">
        <h2 class="gdpr-banner__title">
          {{ showSettings ? 'Your cookie settings' : 'This website uses cookies' }}
        </h2>
        <GdprSettings
          v-if="showSettings"
          :uses-statistics="gdprOptions?.usesStatistics"
          :uses-marketing="gdprOptions?.usesMarketing"
          @accept="onSettingsAccept"
          @back="showSettings = false"
        />
        <GdprNotice
          v-else
          :privacy-url="gdprOptions?.privacyUrl ?? DEFAULT_PRIVACY_URL"
          :cookies-url="gdprOptions?.cookiesUrl ?? DEFAULT_COOKIES_URL"
          :show-manage="!!(gdprOptions?.usesStatistics || gdprOptions?.usesMarketing)"
          @accept="onNoticeAccept"
          @manage="showSettings = true"
        />
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {
  gdprVisible,
  gdprOptions,
  setCookie,
  DEFAULT_PRIVACY_URL,
  DEFAULT_COOKIES_URL
} from 'src/services/gdpr'
import type { ConsentCookieContent } from 'src/services/gdpr'
import GdprNotice from './GdprNotice.vue'
import GdprSettings from './GdprSettings.vue'

const showSettings = ref(false)

const onNoticeAccept = () => {
  acceptAndClose({
    consent: true,
    statistics: gdprOptions.value?.usesStatistics ?? false,
    marketing: gdprOptions.value?.usesMarketing ?? false
  })
}

const onSettingsAccept = (consent: ConsentCookieContent) => {
  acceptAndClose(consent)
}

const acceptAndClose = (consent: ConsentCookieContent) => {
  setCookie(consent)
  gdprVisible.value = false
  showSettings.value = false
  gdprOptions.value?.onAccept?.(consent)
}
</script>

<style scoped>
.gdpr-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5000;
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.12);
  border-top: 4px solid #e4610f;
}

.gdpr-banner__inner {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 24px;
}

.gdpr-banner__title {
  font-size: 16px;
  font-weight: 600;
  color: #1d1d1d;
  margin: 0 0 14px 0;
}
</style>

<style>
.gdpr-btn {
  min-width: 120px;
}

.gdpr-btn--accept {
  background-color: #e4610f !important;
  color: #fff !important;
}

.gdpr-btn--outline {
  border-color: #e4610f !important;
  color: #e4610f !important;
}

.gdpr-btn--manage {
  border-color: #e4610f !important;
  color: #e4610f !important;
  min-width: 180px;
}
</style>
